<template>
  <v-container fluid>
    <v-row>
      <v-col cols="10" offset="1">
        <v-card outlined>
          <v-container fluid>
            <v-row align="center">
              <v-col cols="12" style="position: relative;">
                <div class="company_header">
                  <div class="user_logo mx-4 box" >
                    <UserLogo :src="company.logoUrl" />
                  </div>
                  <div class="box" style="display:inline-block">
                      <CompanyStatus :user="user" :company="company"/>
                  </div>
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-tabs grow v-model="tab">
                  <v-tab key="1" to="/clients/company" href="#profile">{{label("tabCompany")}}</v-tab>
                  <v-tab key="2" to="/clients/company/person" >{{label("tabPerson")}}</v-tab>
                  <v-tab key="3" to="/clients/company/requestors" >スカウト送付者</v-tab>
                  <v-tab key="4" to="/clients/company/scout-templates" >スカウトメッセージテンプレート</v-tab>
                </v-tabs>
                <v-tabs-items :touchless="true" v-model="tab">
                  <v-tab-item value="/clients/company" key="1">
                    <router-view></router-view>
                  </v-tab-item>
                  <v-tab-item value="/clients/company/person" key="2">
                    <router-view></router-view>
                  </v-tab-item>
                  <v-tab-item value="/clients/company/requestors" key="3">
                    <router-view></router-view>
                  </v-tab-item>
                  <v-tab-item value="/clients/company/scout-templates" key="4">
                    <router-view></router-view>
                  </v-tab-item>
                </v-tabs-items>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import {mapGetters} from "vuex";
  import UserLogo from "../../atoms/UserLogo";
  import CompanyStatus from "../../organisms/CompanyStatus";
  import ComponentMixin from "../../ComponentMixin";
  import ApiMixin from "../../../ApiMixin";

  export default {
    mixins: [ComponentMixin, ApiMixin],
    type: "page",
    name: "ClientProfilePage",
    isRequiredLogin: false,
    data () {
      return {
        tab: null
      }
    },
    beforeMount () {
    },
    computed: {
      ...mapGetters("user", ["user"]),
      ...mapGetters("client", ["company"]),
    },
    methods: {
    },
    components: {
      UserLogo,
      CompanyStatus,
    }
  }
</script>

<style scoped lang="sass">
  .company_header
    display: table
  .box
    display: table-cell
    vertical-align: middle
  .user_logo
    display: inline-block
    width: 120px
    max-height: 120px
</style>
